import React from 'react';
import { useParams } from 'react-router-dom';
import { Table, Spin } from 'antd';
import { getAccountsTableColumns } from './utils/getAccountsTableColumns';
import useTablePagination from '../../../../hooks/useTablePagination';
import useFilteredBySearchData from '../../../../hooks/useFilteredBySearchData';
import useTableChange from '../../../../hooks/useTableChange';
import { sortableColumnsData } from '../constants/sortableColumnsData';
import { accountsTableComponents } from './constants/accountTableComponents';
import { modes } from '../../MainHeader/components/Search';
import useHousingStockHousesState from '../../../../hooks/useHousingStockHousesState';

const AccountsTable = ({
  onRowClick,
  accounts = [],
  pagination = true,
  companyName,
  ...props
}) => {
  const { companyId, pageId } = useParams();

  const [loading, filteredBySearchAccounts] = useFilteredBySearchData({
    data: accounts,
    key: 'account',
    mode: modes.accounts,
  });

  const {
    data: sortedAccounts,
    sortedInfo,
    handleTableChange,
  } = useTableChange({
    initialData: filteredBySearchAccounts,
    sortableColumnKeys: sortableColumnsData,
    depsToReset: [companyId],
  });

  const { shownItems: shownAccounts, pagination: paginationBlock } =
    useTablePagination(sortedAccounts);

  const {
    housingStockHousesState: { data: houses },
  } = useHousingStockHousesState();

  const hasHouse = houses?.find((item) => item.houseId === Number(pageId));

  return (
    <Spin spinning={loading}>
      <Table
        {...props}
        dataSource={pagination ? shownAccounts : sortedAccounts}
        components={accountsTableComponents}
        rowKey="bindId"
        pagination={false}
        columns={getAccountsTableColumns(
          sortedInfo,
          hasHouse?.registrationType,
          !!pageId
        )}
        onChange={handleTableChange}
      />
      {pagination && paginationBlock}
    </Spin>
  );
};

export default AccountsTable;
